module.exports = __webpack_public_path__ + "static/methodology-0604fe5acbc208e5b67cd81d17091ac8.jpg";